import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    dash: {
      id: 0,
      link: ""
    }
};

const dashSlice = createSlice({
    name: "dash",
    initialState,
    reducers: {
      setDash(state, actions) {
        state.dash = actions.payload;
      },
    },
  });


export const dashActions = dashSlice.actions;
export default dashSlice;
